<div class="py-4">
  <!-- Loading spinner -->
  @if (usersLoading) {
  <div class="flex justify-center py-10">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  }

  <!-- No org selected -->
  @if (!orgId() && !usersLoading) {
  <div class="text-center py-10 text-gray-400 text-sm">
    {{ 'Please select an organization' | translate }}
  </div>
  }

  <!-- No users -->
  @if (orgId() && !usersLoading && users.length === 0) {
  <div class="text-center py-10 text-gray-400 text-sm">
    {{ 'No users found for this organization' | translate }}
  </div>
  }

  <!-- Users table -->
  @if (orgId() && !usersLoading && users.length > 0) {
  <table mat-table [dataSource]="users" class="w-full">
    <!-- Name -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
      <td mat-cell *matCellDef="let user">{{ user.firstName }} {{ user.lastName }}</td>
    </ng-container>

    <!-- Email -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>{{ 'Email' | translate }}</th>
      <td mat-cell *matCellDef="let user">{{ user.email }}</td>
    </ng-container>

    <!-- Vendor Role -->
    <ng-container matColumnDef="vendorRole">
      <th mat-header-cell *matHeaderCellDef>{{ 'Vendor Role' | translate }}</th>
      <td mat-cell *matCellDef="let user">
        <mat-form-field appearance="fill" class="role-select">
          <mat-select
            [value]="getUserRoleId(user)"
            (selectionChange)="onUserRoleChange(user, $event.value)"
            [disabled]="savingUser[user.userId]"
            placeholder="{{ 'None' | translate }}"
          >
            <mat-option [value]="null">{{ 'None' | translate }}</mat-option>
            @for (role of assignOrgRoles; track role.id) {
            <mat-option [value]="role.id">
              {{ role.role_name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- Visible Statuses -->
    <ng-container matColumnDef="statuses">
      <th mat-header-cell *matHeaderCellDef>{{ 'Visible Statuses' | translate }}</th>
      <td mat-cell *matCellDef="let user">
        @if (user.vendorRole) {
        <app-status-tooltip [allStatuses]="allStatuses" [visibleStatusIds]="getVisibleStatusIdsForUser(user)" />
        } @else {
        <span class="text-gray-400 text-[13px]">--</span>
        }
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
      <td mat-cell *matCellDef="let user">
        <button
          mat-icon-button
          matTooltip="{{ 'Remove Role' | translate }}"
          color="warn"
          (click)="removeUserRole(user)"
          [disabled]="!user.assignmentId || savingUser[user.userId]"
        >
          <mat-icon>person_remove</mat-icon>
        </button>
        @if (savingUser[user.userId]) {
        <mat-spinner diameter="18" class="inline-block align-middle"></mat-spinner>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  }
</div>
